export default Object.freeze({
  FILE: 'FILE',
  GIPHY: 'GIPHY',
  INLINE: 'INLINE',
  ATTACHMENT: 'ATTACHMENT',
  EXTERNAL: 'EXTERNAL',
})
